/**
 * Translations for Reviews Widget
 */

export const translations = {
  nl: {
    // Header
    reviewsFor: 'Reviews voor',
    totalScore: 'Totaal score',
    totalReviews: 'Aantal beoordelingen',
    recommendPercentage: 'Bereid om aan',
    viewCount: 'Aantal leer bekaken',
    writeReview: '✍️ schrijf een review',
    
    // Time
    inLast12Months: 'beoordelingen in de laatste 12 maanden',
    
    // Topics
    chooseImportant: 'Kies wat voor jou belangrijk is',
    chooseImportantSub: 'Klik op een onderwerp en bekijk hoe anderen dit beoordelen',
    
    // Filters
    filters: 'Filters',
    showAllScores: 'Toon alle scores',
    star: 'ster',
    stars: 'sterren',
    
    // Empty states
    noReviews: 'Geen reviews gevonden met deze filters.',
    loading: 'Reviews laden...',
    
    // Sidebar
    reviewOverview: 'Review overzicht',
    positiveSentiment: 'Positief sentiment',
    aiSummary: '✨ AI Samenvatting',
    strongPoints: '👍 Sterke punten',
    attentionPoints: '⚠️ Aandachtspunten',
    generatedBy: 'Gegenereerd door AI op basis van',
    reviews: 'reviews',
    basedOn: 'Gebaseerd op',
    verifiedReviews: 'Geverifieerde reviews',
    verifiedDesc: 'Alle reviews zijn gecontroleerd en afkomstig van echte klanten',
    
    // Review card
    noTitle: 'Geen titel',
    anonymous: 'Anoniem',
    shopReply: 'Reactie',

    // Q&A panel
    qaTitle: 'Vraag het aan klanten',
    qaPlaceholder: 'Stel je vraag over dit product...',
    qaButton: 'Vraag',
    qaAnswerLabel: 'AI antwoord',
    qaLoading: 'Analyseren...',

    // Collapsed bar
    collapsedReviews: '{count} reviews',
    collapsedLoading: 'Reviews laden...',
    positivePercent: '{pct}% positief',
    readReviews: 'Lees reviews',
    drawerTitle: 'Reviews',

    // Popular questions (fallback)
    popularQ1: 'Wat zijn de belangrijkste plus- en minpunten?',
    popularQ2: 'Wat zeggen klanten over de kwaliteit?',
    popularQ3: 'Zou je dit product aanraden?',

    // Summary text template
    summaryText: 'scoort gemiddeld een {rating} uit 10, met {pct}% aanbevelingen. Klanten zijn bijzonder lovend over de razendsnelle levering, de vriendelijke service, en de gebruiksvriendelijke website.'
  },
  
  en: {
    // Header
    reviewsFor: 'Reviews for',
    totalScore: 'Total score',
    totalReviews: 'Total reviews',
    recommendPercentage: 'Willing to recommend',
    viewCount: 'Number of views',
    writeReview: '✍️ write a review',
    
    // Time
    inLast12Months: 'reviews in the last 12 months',
    
    // Topics
    chooseImportant: 'Choose what matters to you',
    chooseImportantSub: 'Click on a topic and see how others rate it',
    
    // Filters
    filters: 'Filters',
    showAllScores: 'Show all scores',
    star: 'star',
    stars: 'stars',
    
    // Empty states
    noReviews: 'No reviews found with these filters.',
    loading: 'Loading reviews...',
    
    // Sidebar
    reviewOverview: 'Review overview',
    positiveSentiment: 'Positive sentiment',
    aiSummary: '✨ AI Summary',
    strongPoints: '👍 Strong points',
    attentionPoints: '⚠️ Points of attention',
    generatedBy: 'Generated by AI based on',
    reviews: 'reviews',
    basedOn: 'Based on',
    verifiedReviews: 'Verified reviews',
    verifiedDesc: 'All reviews are verified and come from real customers',
    
    // Review card
    noTitle: 'No title',
    anonymous: 'Anonymous',
    shopReply: 'Reply',

    // Q&A panel
    qaTitle: 'Ask our customers',
    qaPlaceholder: 'Ask a question about this product...',
    qaButton: 'Ask',
    qaAnswerLabel: 'AI answer',
    qaLoading: 'Analysing...',

    // Collapsed bar
    collapsedReviews: '{count} reviews',
    collapsedLoading: 'Loading reviews...',
    positivePercent: '{pct}% positive',
    readReviews: 'Read reviews',
    drawerTitle: 'Reviews',

    // Popular questions (fallback)
    popularQ1: 'What are the main pros and cons?',
    popularQ2: 'What do customers say about the quality?',
    popularQ3: 'Would you recommend this product?',

    // Summary text template
    summaryText: 'scores an average of {rating} out of 10, with {pct}% recommendations. Customers are particularly positive about the fast delivery, friendly service, and user-friendly website.'
  },
  
  fr: {
    // Header
    reviewsFor: 'Avis pour',
    totalScore: 'Score total',
    totalReviews: 'Nombre d\'avis',
    recommendPercentage: 'Prêt à recommander',
    viewCount: 'Nombre de vues',
    writeReview: '✍️ écrire un avis',
    
    // Time
    inLast12Months: 'avis au cours des 12 derniers mois',
    
    // Topics
    chooseImportant: 'Choisissez ce qui compte pour vous',
    chooseImportantSub: 'Cliquez sur un sujet et voyez comment les autres l\'évaluent',
    
    // Filters
    filters: 'Filtres',
    showAllScores: 'Afficher tous les scores',
    star: 'étoile',
    stars: 'étoiles',
    
    // Empty states
    noReviews: 'Aucun avis trouvé avec ces filtres.',
    loading: 'Chargement des avis...',
    
    // Sidebar
    reviewOverview: 'Aperçu des avis',
    positiveSentiment: 'Sentiment positif',
    aiSummary: '✨ Résumé IA',
    strongPoints: '👍 Points forts',
    attentionPoints: '⚠️ Points d\'attention',
    generatedBy: 'Généré par IA basé sur',
    reviews: 'avis',
    basedOn: 'Basé sur',
    verifiedReviews: 'Avis vérifiés',
    verifiedDesc: 'Tous les avis sont vérifiés et proviennent de vrais clients',
    
    // Review card
    noTitle: 'Sans titre',
    anonymous: 'Anonyme',
    shopReply: 'Réponse',

    // Q&A panel
    qaTitle: 'Posez une question',
    qaPlaceholder: 'Posez votre question sur ce produit...',
    qaButton: 'Demander',
    qaAnswerLabel: 'Réponse IA',
    qaLoading: 'Analyse...',

    // Collapsed bar
    collapsedReviews: '{count} avis',
    collapsedLoading: 'Chargement des avis...',
    positivePercent: '{pct}% positif',
    readReviews: 'Lire les avis',
    drawerTitle: 'Avis',

    // Popular questions (fallback)
    popularQ1: 'Quels sont les principaux avantages et inconvénients ?',
    popularQ2: 'Que disent les clients sur la qualité ?',
    popularQ3: 'Recommanderiez-vous ce produit ?',

    // Summary text template
    summaryText: 'obtient une moyenne de {rating} sur 10, avec {pct}% de recommandations. Les clients sont particulièrement positifs sur la livraison rapide, le service amical et le site web convivial.'
  }
};

export function getTranslation(lang, key) {
  const t = translations[lang] || translations.nl;
  return t[key] || translations.nl[key] || key;
}
